export default __webpack_public_path__ + "static/media/domi-img1.0db5502e.png";